export default "__VITE_ASSET__88a70317__"